import { childOfOrEqual, createRouteName } from "../../../router/functions";
// import { SelectResults } from "./router";

// TODO: Because of unknown reason the string export is undefined in other vuejs Components

export const getBookingListRoute = () => 'booking_list';
export const getBookingListCalendarDateRoute = () => createRouteName(getBookingListRoute, 'calendar_date_id');
export const getBookingListCalendarDateTabRoute = () => createRouteName(getBookingListCalendarDateRoute, 'tab');


export const getBookingCalRoute = () => 'booking_list_calendar';
export const getBookingCalCalendarDateRoute = () => createRouteName(getBookingCalRoute, 'calendar_date_id');
export const getBookingCalCalendarDateTabRoute = () => createRouteName(getBookingCalRoute, 'tab');

export const SelectResults = {
  SELECT: "SELECT",
  SELECT_AUTO: "SELECT_AUTO",
  IGNORE: "IGNORE",
  CLOSE: "CLOSE"
};

export const bookingTemplateListRoute = 'booking_templates';
export const bookingTemplateDetailsRoute = createRouteName(bookingTemplateListRoute, "template_details");;
export const bookingTemplateDetailsTabRoute = createRouteName(bookingTemplateDetailsRoute, "tab");;


export const templateDetailsSelectable = (to, from) => {
  let selectResult = SelectResults.IGNORE;

  if (to && to.name === bookingTemplateListRoute && from && childOfOrEqual(bookingTemplateDetailsRoute)(from.name)) {
    selectResult = SelectResults.CLOSE;
  } else if (childOfOrEqual(bookingTemplateDetailsRoute)(to.name) && !from) {
    selectResult = SelectResults.SELECT_AUTO;
  } else if (childOfOrEqual(bookingTemplateDetailsRoute)(to.name) && from && childOfOrEqual(bookingTemplateDetailsRoute)(from.name) && to.params.booking_template_id != from.params.booking_template_id) {
    selectResult = SelectResults.SELECT;
  } else if (childOfOrEqual(bookingTemplateDetailsRoute)(to.name) && from && from.name == bookingTemplateListRoute) {
    selectResult = SelectResults.SELECT;
  } else if (!from || to.params.booking_template_id == from.params.booking_template_id) {
    selectResult = SelectResults.IGNORE;
  }

  const bookingTemplateId = to && to.params && to.params.booking_template_id;


  return {
    selectResult,
    bookingTemplateId,
  };
};


// If this function matches the calendar Details - sidewindow cane be opened
// export const calendarDateSelectable = (to, from) => {
//   if ([getBookingListCalendarDateTabRoute(), getBookingCalCalendarDateTabRoute()].includes(to.name)) {
//     if (from && from.name.calendar_date_id == to.params.calendar_date_id) {
//       return false;
//     }
//   }
//   const deb = [getBookingListCalendarDateRoute(), getBookingCalCalendarDateRoute()].includes(to.name);

//   if (
//     [getBookingListCalendarDateRoute(), getBookingCalCalendarDateRoute()].includes(to.name) &&
//     (
//       (from && from.name && (
//         childOf(getBookingListRoute(), from.name) ||
//         childOf(getBookingCalRoute(), from.name)
//       )) || (!from)
//     )
//   ) {
//     return true;
//   } else {
//     return false;
//   }
// }
